import React from 'react';
import { IonIcon } from '@ionic/react';
import { IonicButton } from 'ionic-ui';
import {
  documentText,
  arrowForwardOutline,
  checkmarkCircle,
} from 'ionicons/icons';
import ProgressBar from '../../ui/ProgressBar';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { Link } from 'react-router-dom';

const ProfileCompletion: React.FC = () => {
  const profile = useSelector((state: RootState) => state.userProfile);

  if (profile?.profile_progress_percent == 100)
    return (
      <div className="mt-2 p-4 sm:p-6 flex flex-col md:flex-row gap-4 justify-between md:items-center bg-background dark:bg-background-accent border border-border rounded-md">
        <IonIcon
          icon={checkmarkCircle}
          className="h-12 w-12 text-primary dark:text-secondary"
        />

        <div className="flex-1 space-y-2">
          <h6 className="font-semibold high-emphasis-text text-wrap">
            Verification complete
          </h6>
          <ProgressBar progress={profile?.profile_progress_percent} />
        </div>
      </div>
    );

  return (
    <div className="mt-2 p-4 sm:p-6 flex flex-col md:flex-row md:gap-8 gap-6 justify-between md:items-center bg-background dark:bg-background-accent border border-border rounded-md">
      <IonIcon
        icon={documentText}
        className="h-12 w-12 text-primary dark:text-secondary"
      />

      <div className="flex-1 ">
        <h6 className="font-semibold high-emphasis-text text-wrap">
          Complete your verification process
        </h6>
        <p className="medium-emphasis-text">
          Please complete your profile to proceed.
        </p>
        <ProgressBar progress={profile?.profile_progress_percent ?? 0} />
      </div>

      <Link to="/dashboard/get-started" className="hover:!opacity-100">
        <IonicButton
          variant="lite"
          type="button"
          size="xlg"
          className="button-with-icon border-primary hover:bg-primary  hover:text-white group"
        >
          <span>Continue</span>
          <IonIcon
            icon={arrowForwardOutline}
            className="high-emphasis-text  group-hover:text-white"
          />
        </IonicButton>
      </Link>
    </div>
  );
};

export default ProfileCompletion;
